// Fragno 1 renames the brand in copy from "ID.me" to "IDMe" (uppercase "ID.ME" to "IDME"). With
// the flag on, boot rewrites every loaded translation once, so flag-off users never run this.
// Exceptions:
// - "ID.me LLC" (and "ID.ME LLC", "ID.me, LLC") stays: legal keeps the company's legal name.
// - Email addresses, domains and URLs stay ("Privacy@ID.me", "https://ID.me/help", "ID.me/help"),
//   so a match right after "@", ".", "/" or an ASCII letter or digit, or right before "/", is
//   skipped. Lowercase "id.me" is never matched.
import { sendToSentry } from '../utils/error';

const BRAND = /ID\.(me|ME)\b(?!,?[ \u00a0]LLC|\/)/g;
const REBRANDED = { me: 'IDMe', ME: 'IDME' };
const PART_OF_ADDRESS = /[@./\w]/;

export const rebrandCopy = (text) =>
  text.replace(BRAND, (match, suffix, offset) =>
    PART_OF_ADDRESS.test(text.charAt(offset - 1)) ? match : REBRANDED[suffix],
  );

const rebrandNode = (node) => {
  if (typeof node === 'string') return rebrandCopy(node);
  if (Array.isArray(node)) return node.map(rebrandNode);
  if (node === null || typeof node !== 'object') return node;
  return Object.fromEntries(
    Object.entries(node).map(([key, value]) => [key, rebrandNode(value)]),
  );
};

export const applyBrandCopy = (i18n) => {
  try {
    Object.entries(i18n.store.data).forEach(([lng, namespaces]) => {
      Object.entries(namespaces).forEach(([ns, bundle]) => {
        i18n.addResourceBundle(lng, ns, rebrandNode(bundle), true, true);
      });
    });
    document.title = rebrandCopy(document.title);
  } catch (error) {
    sendToSentry(error);
  }
};
